
    import {useStore} from "@/store";
    import checkItem from './checkItem/checkItem.vue';
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";

    interface State {
        dataList: object[];
        tocOnlyShowFlaw: boolean;
        isRenderVersion241226: boolean;
    }
    export default defineComponent({
        name: 'checkCont',
        setup() {
            let state: State = reactive({
                dataList: [],
                tocOnlyShowFlaw: false,
                isRenderVersion241226: false
            });
            // 格式化时间
            function formatDate(dateTime) {
                if(!dateTime) {
                    return 0;
                }
                let reg1 = /[- :]/g;
                let dateNum = Number(dateTime.replace(reg1, ''));
                return dateNum
            }
            let store = useStore()
            let version241226 = computed(() => {
                return store.state.version241226 || 0
            })
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {checkItemModules, orderDate, checkComponents} = data;
                // state.isRenderVersion241226 = formatDate(orderDate) >= version241226.value;
                state.isRenderVersion241226 = true;
                state.dataList = state.isRenderVersion241226 ? checkComponents : checkItemModules;
            }, {immediate: true})
            let tocOnlyShowFlawS: ComputedRef<{}> = computed<{}>(() => store.state.tocOnlyShowFlaw)
            watch(tocOnlyShowFlawS, (data: any) => {
                // console.log('checkCont:tocOnlyShowFlaw:', data);
                state.tocOnlyShowFlaw = data;
            }, {immediate: true})
            //  {immediate: false}
            return {
                state
            }
        },
        components: {
            checkItem
        }
    })
